// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "04068fc820b4ac3f","396": "390793fcba61f3e1","460": "a6b1b74d5d33d5ae","917": "17ee8d22a0458dd7","985": "7a232460c10e41c5",}[chunkId] + ".chunk.js"
}